import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PaymentErrorBanner.module.scss'

interface PaymentErrorBannerProps {
  heading?: string
  message: string
  severity: 'error' | 'warning'
}

export const PaymentErrorBanner = ({
  message,
  severity,
  heading,
}: PaymentErrorBannerProps) => {
  const { t } = useTranslation(['Errors', 'Common'])

  if (!message) {
    return null
  }

  return (
    <KibTopLevelAlert
      className={styles.paymentErrorBanner}
      heading={heading ?? t('Errors:DEFAULT_ERROR')}
      severity={severity}
    >
      {message}
    </KibTopLevelAlert>
  )
}
